import { render, staticRenderFns } from "./collecPreTestingDialog.vue?vue&type=template&id=b557b6d6&scoped=true"
import script from "./collecPreTestingDialog.vue?vue&type=script&lang=js"
export * from "./collecPreTestingDialog.vue?vue&type=script&lang=js"
import style0 from "./collecPreTestingDialog.vue?vue&type=style&index=0&id=b557b6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b557b6d6",
  null
  
)

export default component.exports